import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ReportProposalPage } from './report-proposal.page';

const routes: Routes = [
  {
    path: '',
    component: ReportProposalPage
  },
  {
    path: 'report-proposal-detail',
    loadChildren: () => import('./report-proposal-detail/report-proposal-detail.module').then( m => m.ReportProposalDetailPageModule)
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportProposalPageRoutingModule {}
